"use client";

import { useId } from "react";

/**
 * Lorenzo wordmark — the exact vector from lorenzolighting.com.
 * Paths recolour via `.brand__mark svg path { fill: currentcolor }` (globals.css),
 * so it inherits the brand/footer text colour. `clipPath` id is per-instance so
 * the header and footer copies don't collide.
 */
export function LorenzoMark({ className }: { className?: string }) {
  const clip = `lorenzo-mark-${useId().replace(/:/g, "")}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="196"
      height="40"
      viewBox="0 0 196 40"
      fill="none"
      role="img"
      aria-label="Lorenzo"
      className={className}
    >
      <g clipPath={`url(#${clip})`}>
        <path
          d="M7.98054 18.1836C8.70455 18.1845 9.39943 18.47 9.91411 18.9783L13.7691 22.8259C14.2872 23.3359 14.5824 24.0308 14.5895 24.7571V40H13.1351L10.776 23.5376C10.6213 22.4512 10.0768 21.4571 9.2448 20.7397C8.41303 20.0228 7.34953 19.63 6.25057 19.635H0V18.1836H7.98054Z"
          fill="#F0F1F2"
        />
        <path
          d="M43.7016 26.0767C43.7049 28.0039 42.9432 29.8543 41.5827 31.2219L41.5352 31.2695H56.1064V32.7222H40.0807L40.0746 32.7283V7.27173H43.7016V26.0767Z"
          fill="#F0F1F2"
        />
        <path
          d="M94.7193 7.22412C96.6515 7.22412 98.5051 7.99045 99.8714 9.35425C101.238 10.718 102.005 12.5684 102.005 14.4971C102.005 16.4255 101.237 18.275 99.8714 19.6387C98.7782 20.7298 97.3728 21.4363 95.8653 21.676C96.4058 21.8711 96.9302 22.1145 97.4319 22.4036C98.9209 23.2616 100.158 24.4952 101.017 25.9814L104.92 32.7283H100.73L95.3423 23.4363C95.0581 22.9439 94.6489 22.5341 94.156 22.2498C93.6632 21.9655 93.1037 21.8163 92.5346 21.8164V21.7688H89.6184V20.6812H92.3724C93.1585 20.6812 93.9369 20.5261 94.6632 20.2258C95.3895 19.9255 96.0494 19.4855 96.6053 18.9307C97.1612 18.3758 97.6028 17.7172 97.9037 16.9922C98.2044 16.2673 98.3596 15.4904 98.3596 14.7058C98.3596 13.9213 98.2044 13.1443 97.9037 12.4194C97.6028 11.6945 97.1612 11.0358 96.6053 10.481C96.0494 9.92608 95.3895 9.48487 94.6632 9.18457C93.937 8.88441 93.1584 8.73047 92.3724 8.73047H85.2733L85.3209 8.77808C86.6861 10.1433 87.4527 11.9943 87.4519 13.9233L87.4336 32.7283H83.8116V7.27173L94.7193 7.22412Z"
          fill="#F0F1F2"
        />
        <path
          d="M107.112 7.27783H123.138V8.73047H108.572L108.62 8.77808C109.985 10.1433 110.752 11.9942 110.751 13.9233V31.2756H123.144V32.7283H107.106V7.27173L107.112 7.27783Z"
          fill="#F0F1F2"
        />
        <path
          d="M129.627 7.27173C130.267 7.27066 130.897 7.43871 131.451 7.75879C132.005 8.07884 132.464 8.53977 132.782 9.09424L145.001 30.2136V7.27173H146.455V32.7283H142.247L128.239 8.50952V32.7283H126.783V7.27173H129.627Z"
          fill="#F0F1F2"
        />
        <path
          d="M169.042 8.73047L156.172 28.5925C155.456 29.6995 154.452 30.592 153.268 31.1743L153.06 31.2756H169.036V32.7283H150.095V31.2695L164.707 8.72437H150.102V7.27173H169.042V8.73047Z"
          fill="#F0F1F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.3969 7.27173C70.7787 7.27179 74.0225 8.61288 76.4138 10.9998C78.8051 13.3867 80.148 16.6244 80.148 20C80.148 22.5173 79.3998 24.9785 77.9987 27.0715C76.5975 29.1644 74.6058 30.7958 72.276 31.759C69.9461 32.7222 67.382 32.974 64.9087 32.4829C62.4354 31.9918 60.1633 30.7801 58.3801 29.0002C56.5968 27.2202 55.3829 24.9519 54.8909 22.4829C54.3989 20.014 54.6512 17.4551 55.6163 15.1294C56.5814 12.8038 58.2156 10.8163 60.3125 9.41772C62.4094 8.01917 64.875 7.27173 67.3969 7.27173ZM75.2751 15.4529C72.1561 10.063 66.0971 7.72589 61.7389 10.2356C57.3809 12.7454 56.3817 19.1573 59.5005 24.5471C62.6194 29.9368 68.6773 32.2736 73.0355 29.7644C77.3997 27.2547 78.3939 20.8427 75.2751 15.4529Z"
          fill="#F0F1F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.249 7.27173C186.631 7.2718 189.874 8.6129 192.266 10.9998C194.657 13.3867 196 16.6244 196 20C196 22.5173 195.252 24.9785 193.851 27.0715C192.45 29.1644 190.458 30.7958 188.128 31.759C185.798 32.7222 183.234 32.974 180.761 32.4829C178.287 31.9918 176.015 30.7801 174.232 29.0002C172.449 27.2202 171.234 24.9519 170.742 22.4829C170.25 20.014 170.503 17.455 171.468 15.1294C172.433 12.8038 174.068 10.8163 176.164 9.41772C178.261 8.01917 180.727 7.27173 183.249 7.27173ZM191.139 15.4529C188.02 10.063 181.961 7.72589 177.603 10.2356C173.245 12.7453 172.246 19.1572 175.365 24.5471C178.484 29.9368 184.541 32.2737 188.894 29.7644C193.252 27.2547 194.258 20.8427 191.139 15.4529Z"
          fill="#F0F1F2"
        />
        <path
          d="M14.7444 16.4624C14.8987 17.5457 15.4401 18.5372 16.2683 19.2542C17.0965 19.9711 18.1565 20.3658 19.2528 20.365H25.5034V21.8164H17.4984C16.7744 21.8155 16.0796 21.53 15.5649 21.0217L11.7282 17.1741C11.2189 16.6602 10.9317 15.9658 10.9309 15.2429V0H12.3865L14.7444 16.4624Z"
          fill="#F0F1F2"
        />
        <path
          d="M122.407 20.7227H112.937V19.2712H122.407V20.7227Z"
          fill="#F0F1F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M194.641 7.96509C194.703 7.95929 194.766 7.9663 194.825 7.98584C194.883 8.00532 194.937 8.03729 194.983 8.07861C195.029 8.12018 195.067 8.17096 195.093 8.22754C195.118 8.28393 195.131 8.34516 195.132 8.40698C195.141 8.50858 195.11 8.61023 195.047 8.69019C194.983 8.7701 194.892 8.82305 194.791 8.83789L195.198 9.43481H194.898L194.533 8.8855H194.24V9.43481L193.994 9.41772V7.96509H194.641ZM194.24 8.67065H194.563C194.742 8.67065 194.844 8.58053 194.844 8.41919C194.844 8.25806 194.748 8.17993 194.569 8.17993H194.216L194.24 8.67065Z"
          fill="#F0F1F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M194.809 7.26685C195.093 7.31897 195.356 7.45396 195.564 7.65503C195.771 7.85603 195.913 8.11403 195.973 8.396C196.034 8.67825 196.01 8.97262 195.902 9.24072C195.795 9.50875 195.61 9.73895 195.372 9.90234C195.134 10.0657 194.852 10.1551 194.563 10.1587C194.371 10.1626 194.18 10.1287 194.002 10.0586C193.824 9.98847 193.661 9.88301 193.524 9.74976C193.386 9.61635 193.276 9.45704 193.201 9.28101C193.125 9.10502 193.087 8.91574 193.085 8.72437C193.08 8.43591 193.161 8.15257 193.318 7.91016C193.475 7.66772 193.7 7.47659 193.965 7.36206C194.231 7.24754 194.524 7.21475 194.809 7.26685ZM194.288 7.55249C194.056 7.5986 193.843 7.7125 193.675 7.87964C193.508 8.04677 193.393 8.2594 193.347 8.49121C193.301 8.72301 193.325 8.96378 193.415 9.18213C193.506 9.40013 193.659 9.58682 193.856 9.71802C194.052 9.84931 194.284 9.91941 194.521 9.91943C194.678 9.91943 194.834 9.88794 194.98 9.82788C195.125 9.76782 195.257 9.68001 195.368 9.56909C195.479 9.45836 195.567 9.3267 195.627 9.18213C195.687 9.03717 195.718 8.88127 195.718 8.72437C195.718 8.48807 195.649 8.25679 195.517 8.0603C195.386 7.86377 195.198 7.71008 194.98 7.61963C194.761 7.52928 194.52 7.50651 194.288 7.55249Z"
          fill="#F0F1F2"
        />
      </g>
      <defs>
        <clipPath id={clip}>
          <rect width="196" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
